export default "### Copyrights\n\n[Here you can insert the copyright notices for this software...]\n"